import Vue from 'vue';
import {
  Main,
  Container,
  Header,
  Aside,
  Dialog,
  Row,
  Col,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Input,
  Card,
  Message,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Loading,
  Pagination,
  Image,
  Drawer,
  Tag,
  Select,
  Option,
  Radio,
  RadioButton,
  RadioGroup,
  Notification,
  DatePicker,
  TimePicker,
  Slider,
  InputNumber,
  Popover,
  Autocomplete,
  Checkbox,
  CheckboxGroup,
  Switch,
  MessageBox,
  Popconfirm,
  Table,
  TableColumn,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Transfer,
  Alert,
  Tabs,
  TabPane,
  Rate,
  Carousel,
  CarouselItem,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(Main);
Vue.use(Container);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Card);
Vue.use(Aside);
Vue.use(Dialog);
Vue.use(Header);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(MenuItem);
Vue.use(Loading.directive);
Vue.use(Pagination);
Vue.use(Image);
Vue.use(Drawer);
Vue.use(Tag);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Slider);
Vue.use(InputNumber);
Vue.use(Popover);
Vue.use(Autocomplete);
Vue.use(ButtonGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Popconfirm);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Transfer);
Vue.use(Alert);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Rate);
Vue.use(Carousel);
Vue.use(CarouselItem);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
